var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('polaris-choice', {
    attrs: {
      "label": _vm.label,
      "label-hidden": _vm.labelHidden,
      "id": _vm.realId,
      "help-text": _vm.helpText
    }
  }, [(_vm.$slots.helpText) ? _c('template', {
    slot: "helpText"
  }, [_vm._t("helpText")], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "Polaris-RadioButton"
  }, [_c('input', {
    staticClass: "Polaris-RadioButton__Input",
    attrs: {
      "id": _vm.realId,
      "name": _vm.name,
      "type": "radio",
      "disabled": _vm.disabled,
      "aria-describedby": _vm.helpText ? _vm.id + 'HelpText' : ''
    },
    domProps: {
      "value": _vm.value,
      "checked": _vm.checked
    },
    on: {
      "change": _vm.onChange,
      "focus": _vm.onFocus,
      "blur": _vm.onBlur
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "Polaris-RadioButton__Backdrop"
  }), _vm._v(" "), _c('div', {
    staticClass: "Polaris-RadioButton__Icon"
  })])], 2)
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-a93fa704", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a93fa704","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PolarisRadioButton.vue
// module id = 250
// module chunks = 0